export { Views as ViewsWidget } from './Views';
